import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var BoundsPickerEvent = /** @class */ (function (_super) {
    __extends(BoundsPickerEvent, _super);
    function BoundsPickerEvent(type, boundsPicker) {
        var _this = _super.call(this, type) || this;
        _this._boundsPicker = boundsPicker;
        return _this;
    }
    Object.defineProperty(BoundsPickerEvent.prototype, "boundsPicker", {
        get: function () {
            return this._boundsPicker;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clones the event.
     * @return An exact duplicate of the current object.
     */
    BoundsPickerEvent.prototype.clone = function () {
        return new BoundsPickerEvent(this.type, this._boundsPicker);
    };
    /**
     *
     */
    BoundsPickerEvent.INVALIDATE_BOUNDS = 'invalidateBounds';
    return BoundsPickerEvent;
}(EventBase));
export { BoundsPickerEvent };
